import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SidebarItemComponent } from './components/sidebar-item/sidebar-item.component';
import { IconModule } from 'studio-components/icon/icon.module';
import { SidebarGroupComponent } from './components/sidebar-group/sidebar-group.component';
import { SidebarContentLayoutComponent } from './components/sidebar-content-layout/sidebar-content-layout.component';

const components = [
  SidebarComponent,
  SidebarItemComponent,
  SidebarGroupComponent,
  SidebarContentLayoutComponent,
];

@NgModule({
  declarations: [components],
  imports: [CommonModule, IconModule],
  exports: [components],
})
export class SidebarModule {}
